
import { useEffect } from "react";
import { loadCollection } from "../util/loadCollection";

export default function StoreCollection() {
  useEffect(() => {
    loadCollection()
  })

  return (
    <div>
      <div id='collection-component-1740168313908'></div>
    </div>
  );
}